import { StepContainer } from '../components/StepContainer'
import { SingleSelect } from '../components/SingleSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { DietKnowledge } from '../types/onboarding'

const options: { value: DietKnowledge; label: string; emoji: string; description: string }[] = [
  { value: 'beginner', label: 'Beginner', emoji: '🌱', description: "I'm just starting to learn" },
  { value: 'some', label: 'Some Knowledge', emoji: '📚', description: 'I know the basics' },
  { value: 'intermediate', label: 'Intermediate', emoji: '🎓', description: 'I know which foods to watch' },
  { value: 'expert', label: 'Expert', emoji: '🏆', description: 'I track nutrients carefully' },
]

export function DietKnowledgeStep() {
  const { data, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="How much do you know about kidney diets?"
      showContinue={false}
    >
      <SingleSelect
        options={options}
        value={data.dietKnowledge}
        onChange={(value) => goNext({ dietKnowledge: value })}
      />
    </StepContainer>
  )
}
